import { createVNode as n, mergeProps as c } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ExcleTwoTone.js";
import m from "../components/PfIcon.js";
const o = (e, r) => {
  const t = {
    ...e,
    ...r.attrs
  };
  return n(m, c(t, {
    icon: l
  }), null);
};
o.displayName = "ExcleTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
